import Template from "./template.vue";

const ImagePreview = {};

ImagePreview.install = function(Vue) {
  const VueImagePreview = Vue.extend(Template);
  let imagePreview = null;

  Vue.prototype.$preview = (options) => {
    if (!imagePreview) {
      imagePreview = new VueImagePreview().$mount();
      document.body.appendChild(imagePreview.$el);
    }
    imagePreview.show(options);
  };
};

export default ImagePreview;
